const axios = require('axios').default;
const { DateTime } = require('luxon');
import slugify from 'slugify';
import SHA256 from 'crypto-js/sha256.js';
//import jsonConcat from 'json-concat';

import { ConfigData } from "src/config.js";

const loopRequests = async (keySetData) => {
    var moviesData = {};
    console.log('Start')
    /*
    for (var i=0; i<keySetData.length; i++) {
       var keySet = keySetData[i];
       console.log(keySet);
       var _moviesData = await sendGetRequest(keySet);
       moviesData = Object.assign(moviesData, _moviesData);
    }
    */
    var _moviesDataA = await sendGetRequest('b');
    moviesData = Object.assign(moviesData, _moviesDataA);

    /*
    var _moviesDataB = await sendGetRequest('3');
    moviesData = Object.assign(moviesData, _moviesDataB);

    var _moviesDataC = await sendGetRequest('4');
    moviesData = Object.assign(moviesData, _moviesDataC);

    var _moviesDataD = await sendGetRequest('5');
    moviesData = Object.assign(moviesData, _moviesDataD);

    var _moviesDataE = await sendGetRequest('6');
    moviesData = Object.assign(moviesData, _moviesDataE);
    */
    
    console.log('End');
    return moviesData;
}

export const sendAllRequest = async () => {    
    const getURL = ConfigData.movieURL + 'list.json';

    const headers = {"Access-Control-Allow-Origin": "*"};

    try {
        let res = await axios({
              method: 'GET',
              url: getURL,
              timeout: 8000,
              headers: headers,
         })
         if(res.status === 200){
             //console.log(res.data);
         }
         var keySetData = res.data.data;
         var moviesData = await loopRequests(keySetData);
         return moviesData;
     }
     catch (err) {
         console.error(err);
     }
};

export const sendGetRequest = async (keySet) => {    
    const getURL = ConfigData.movieURL + keySet +'.json';
    const headers = {"Access-Control-Allow-Origin": "*"};
    try {
        let res = await axios({
              method: 'GET',
              url: getURL,
              timeout: 8000,
              headers: headers,
         })
         if(res.status === 200){
             //console.log(res.data);
         }
         return res.data
     }
     catch (err) {
         console.error(err);
     }
};

// http://localhost:8080/movie/tt0004002-the-gangsters-of-new-york-1914/?page=1
// http://localhost:8080/movie/985939/?page=1
export const getMovieData = async (pid) => {
    const keySet = getKeySet(pid);
    const movieData = await sendGetRequest(keySet);
    var data = {}
    if (movieData) {
        if (movieData[pid]) {
            data = movieData[pid];
        }
    }
    return data;
}

export const getStaticMovieData = (movies, pid) => {
    /*
    const keySet = getKeySet(pid);
    const movieData = await sendGetRequest(keySet);
    var data = {}
    if (movieData) {
        if (movieData[pid]) {
            data = movieData[pid];
        }
    }
    return data;
    */
}

export const formatDate = (_date) => {
    var date = DateTime.fromISO(_date);
    var formattedDate = date.toFormat('LLL dd yyyy');
    return formattedDate;
}

export const formatSlug = (movie) => {
    let title = slugify(movie.title, {
        replacement: '-',  // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: true,      // convert to lower case, defaults to `false`
        strict: true,     // strip special characters except replacement, defaults to `false`
        locale: 'en',       // language code of the locale to use
        trim: true         // trim leading and trailing replacement chars, defaults to `true`
    });
    title = title.substring(0, 80);

    let date = movie.release_date.split('-')[0];
    let imdb = movie.imdb_id;
    let slug_imdb = slugify(imdb + '-' + title + '-' + date, {
        replacement: '-',  // replace spaces with replacement character, defaults to `-`
        remove: undefined, // remove characters that match regex, defaults to `undefined`
        lower: true,      // convert to lower case, defaults to `false`
        strict: true,     // strip special characters except replacement, defaults to `false`
        locale: 'en',       // language code of the locale to use
        trim: true         // trim leading and trailing replacement chars, defaults to `true`
    });

    if (imdb) {
        return slug_imdb;
    } else {
        return null;
    }
}


export const getKeySet = (slug) => {

    console.log('getKeySet', slug);

    var key = slug;
    var hash = SHA256(key);
    var hex = hash.toString();
    var keySet = hex.charAt(0);

    /*
    var keySet = null;
    var keyLetter = key.split('-')[1];
    if (keyLetter) {
        if (keyLetter === 'the' && key.split('-')[2]) {
            keyLetter = key.split('-')[2];
        }
        var keyLetterA = (keyLetter.charAt(0)) ? keyLetter.charAt(0) : '_';
        var keyLetterB = (keyLetter.charAt(1)) ? keyLetter.charAt(1) : '_';

        keySet = keyLetterA + keyLetterB;
    }
    */
    return keySet;
}

export default { sendAllRequest, sendGetRequest, getMovieData, formatDate, formatSlug, getKeySet };